<template>
	<PayVideoSeriesShell
		:data="data"
		:block-id="blockId"
		:editable="editable"
		:active="active"
		:h5="h5"
		:compact="compact"
		:id-key="idKey"
		@select="$emit('select')"
	/>
</template>

<script>
	import PayVideoSeriesShell from '../shared/PayVideoSeriesShell.vue';

	export default {
		name: 'GBlockPayVideoSeries',
		components: { PayVideoSeriesShell },
		props: {
			data: {
				type: Object,
				required: true,
			},
			blockId: {
				type: String,
				default: '',
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			compact: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
		},
		emits: ['select'],
	};
</script>
